import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function BranchFilter({ value, onChange }) {
  const [branches, setBranches] = useState([]);
  useEffect(() => {
    api.get("/branches").then((r) => setBranches(r.data.items || [])).catch(() => {});
  }, []);
  if (!branches.length) return null;
  return (
    <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
      <SelectTrigger className="h-8 w-52 text-xs" data-testid="branch-filter">
        <SelectValue placeholder="All branches" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All branches (consolidated)</SelectItem>
        {branches.map((b) => (
          <SelectItem key={b.id} value={b.id}>{b.name} · {b.code}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
